import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const AssistanceProgramBasicInfoComponent = ({ onInnerBasicFormChange, selectedAssistancePrograms, termsLibraries }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer

                    label="Active"
                    name="IsActive"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsActive'

                        )
                    }}
                    type="checkbox"
                    value={selectedAssistancePrograms?.IsActive}
                />

                <InputContainer

                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedAssistancePrograms?.Name}
                />

                <InputContainer

                    label="DisplayOrder"
                    name="DisplayOrder"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DisplayOrder'

                        )
                    }}
                    type="number"
                    value={selectedAssistancePrograms?.DisplayOrder}
                />

                <InputContainer

                    label="TermsLibrary Name"
                    labelField="Name"
                    list={termsLibraries}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'TermsLibraryId'
                        )
                    }}
                    optionName='Choose TermsLibrary'
                    type="select"
                    value={selectedAssistancePrograms?.TermsLibraryId}
                    valueField="Id"
                />

                <InputContainer

                    label="StartDate"
                    name="StartDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'StartDateUtc'
                        )
                    }}
                    type="date"
                    value={selectedAssistancePrograms?.StartDateUtc}
                />
                <InputContainer

                    label="EndDate"
                    name="EndDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'EndDateUtc'
                        )
                    }}
                    type="date"
                    value={selectedAssistancePrograms?.EndDateUtc}
                />

                <InputContainer

                    label="Always Enabled"
                    name="IsAlwaysEnabled"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsAlwaysEnabled'

                        )
                    }}
                    type="checkbox"
                    value={selectedAssistancePrograms?.IsAlwaysEnabled}
                />

                <InputContainer

                    label="Remarks"
                    name="Remarks"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Remarks'

                        )
                    }}
                    type="text"
                    value={selectedAssistancePrograms?.Remarks}
                />
                <div className='col-span-full'>
                    <InputContainer

                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedAssistancePrograms?.Description}
                    />
                </div>


            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default AssistanceProgramBasicInfoComponent;
